import React from 'react';

var MobileHeaderColumn = function (_a) {
    var children = _a.children, position = _a.position;
    return (React.createElement("div", { className: "pgc-".concat(position, "-m-header") }, children));
};

export { MobileHeaderColumn };
